<template>
  <div class="rejected-list">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        历史审批意见
      </div>
      <div class="rj-page-card__content">
        <el-table
          :data="rejectedList"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="rapproveUserName"
            label="审批人"
            min-width="100"
            align="left"
          />
          <el-table-column
            prop="rapproveContent"
            label="审批意见"
            align="left"
            min-width="140"
          />
          <el-table-column
            prop="rcreatedTime"
            label="审批时间"
            align="left"
            min-width="140"
          />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RejectedList',
  data () {
    return {
      rejectedList: this.approveLogList
    };
  },
  watch: {
    approveLogList (val) {
      this.rejectedList = val;
    }
  },
  props: {
    approveLogList: {
      type: Array,
      default: () => { return []; }
    }
  }
};
</script>

<style lang="scss">

</style>
